import React, { PropsWithChildren } from 'react';

type Props = {
  className?: string;
} & PropsWithChildren;

export default function SettingsMainContentWrapper({
  className = '',
  children,
}: Props) {
  return (
    <div
      className={`${className} min-[420px]:p-6 w-full md:col-span-3 min-[420px]:rounded-xl min-[420px]:border min-[420px]:border-border`}
    >
      {children}
    </div>
  );
}
